import { inject, injectable } from 'inversify';
import AuthRepository from 'src/features/auth/data/AuthRepository';
import {
  LoginData,
  LoginParams,
} from 'src/features/auth/domain/AuthRepositoryInterface';
import { LoginUseCaseInterface } from 'src/features/auth/domain/useCases/types';

@injectable()
class LoginUseCase implements LoginUseCaseInterface {
  @inject(AuthRepository) private authRepository!: AuthRepository;

  async execute(params: LoginParams): Promise<LoginData> {
    const sessionData = await this.authRepository.login(params);

    return sessionData;
  }
}

export default LoginUseCase;
